import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Section4 = () => {
  const { t, i18n } = useTranslation();


  return (
    <div
      style={{
        minHeight: '680px',
        backgroundColor: '#000',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-12 py-5">
            <div className="mt-5" style={{ maxWidth: '450px' }}>
              <h3 className="title white mt-5">
                {t('trailer')}{' '}
                <span className="gradient-text">{t('redefines')}</span>{' '}
                {t('standards')}
              </h3>
              <p className="text white mt-4">{t('ecoEnergyTrailer')}</p>
            </div>
            <div className="row">
              <div className="col-5">
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-5">{t('height')}</p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-5">{t('interiorHeight')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-2">{t('width')}</p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-2">{t('interiorWidth')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-2">{t('depth')}</p>
                  </div>
                  <div className="col-8 mt-2">
                    {' '}
                    <p className="text white mt-2">{t('interiorDepth')}</p>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="row">
                  <div className="col-5">
                    <p className="title white mt-5">
                      {t('volume')}
                      <span style={{ fontSize: '14px' }}>
                        {t('unitCubicFeet')}
                      </span>
                    </p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-5">{t('interiorVolume')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5">
                    <p className="title white mt-2">
                      {t('maxLoad')}
                      <span style={{ fontSize: '14px' }}>
                        {t('unitPounds')}
                      </span>
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="text white mt-2">{t('maxLoadLabel')} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 hide-mobile">
            <img
              src="./img/blue-print.jpg"
              height={680}
              style={{
                zIndex: 100,
                position: 'relative',
                width: 'auto',
                marginLeft: '60px',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;
